const o = ({
  value: r,
  locale: u = "en-AU",
  currencyCode: e = "AUD",
  withSymbol: t = !1,
  formatOptions: m
}) => {
  if (r === "") return "";
  const n = Number(r);
  if (Number.isNaN(n))
    return r ?? "";
  const c = new Intl.NumberFormat(u, {
    style: "currency",
    currency: e,
    currencyDisplay: t ? "symbol" : "code",
    ...m
  }).format(n);
  return t ? c : c.replace(e, "").trim();
};
export {
  o as formatCurrency
};
